import { render } from "./SwitchSkin.vue?vue&type=template&id=c4ebc1c2&scoped=true&ts=true"
import script from "./SwitchSkin.vue?vue&type=script&lang=ts"
export * from "./SwitchSkin.vue?vue&type=script&lang=ts"

import "./SwitchSkin.vue?vue&type=style&index=0&id=c4ebc1c2&scoped=true&lang=scss"

import exportComponent from "/home/build/jenkins/workdir/workspace/fast-build/fast-build/67161/vshow-main/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4ebc1c2"]])

export default __exports__